

import axios from 'axios'
import React, { useContext, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import UserContext from '../context/UserContext'

const Autoaccept = () => {
const nav= useNavigate()
    const [param] = useSearchParams()

    const {apiURL} = useContext(UserContext)
    useEffect(() => {
const getauto = async() => {
    //console.log('Pam is so beautiful. Damn what a beautiful ass')
   let newid = {id:param.get('id')}
  await axios.post(`${apiURL}/image/autoaccept`,newid)
  .then(res => {
    if(res.data.status !== 200){
nav('/')
    }
    console.log(res.data)
})
  .catch(err => console.log(err))

}
getauto()
    },[])


  return (
    <div>Autoaccept</div>
  )
}

export default Autoaccept